import React, { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const UniversalAssetRedirect: React.FC = () => {
  const { uid } = useParams<{ uid: string }>()
  const navigate = useNavigate()
  const { isAuthenticated, isLoading } = useAuth()

  useEffect(() => {
    if (!isLoading && uid) {
      if (isAuthenticated) {
        // Авторизованный пользователь - перенаправляем на полную страницу прибора
        navigate(`/asset/${uid}`, { replace: true })
      } else {
        // Неавторизованный пользователь - перенаправляем на страницу для заказчиков
        navigate(`/customer/asset/${uid}`, { replace: true })
      }
    }
  }, [isAuthenticated, isLoading, uid, navigate])

  // Показываем загрузку во время проверки авторизации
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600 dark:text-gray-400">Перенаправление...</p>
      </div>
    </div>
  )
}

export default UniversalAssetRedirect
